import { Dot } from 'lucide-react';

const NotificationDot = () => {
  return (
    <div className="absolute -top-6 -right-9">
      <Dot className="text-destructive" size={55} />
    </div>
  );
};

export default NotificationDot;
